module.exports = __webpack_public_path__ + "img/M800.dad1f19.jpg";